import   React                 ,
       { useState              } from 'react';

import   classNames              from 'classnames';

import   styles                  from './MediaCategoryManager.module.scss';

import   MediaCategoryCreation   from './MediaCategoryCreation';
import   MediaCategoryList       from './MediaCategoryList';

import { MediaCategory }         from '../../../dataTypes/mediaManagment/types';

export interface MediaCategoryManagerProps {
  onCategoryCreated?: (createdCategory: MediaCategory) => void;
  /** Ouvert dans une fenêtre (Box) : la hauteur colle au contenu. */
  embedded?: boolean;
  /** Rendu à l'intérieur d'une autre page (MediaList) qui porte déjà le fond et les marges. */
  nested?: boolean;
  /** Si fourni, affiche le bouton de retour "Vidéo" en haut à droite. */
  onBackToMedia?: () => void;
}

export const MediaCategoryManager = ({ onCategoryCreated, embedded = false, nested = false, onBackToMedia }: MediaCategoryManagerProps = {}) => {

  const [ refreshList          , setRefreshList          ] = useState<boolean>(false);
  const [ mediaCategoriesCount , setMediaCategoriesCount ] = useState<number>(0);

  const handleMediaCategoryCreation = (createdCategory?: MediaCategory) => {
    setRefreshList((prevState) => !prevState);
    if (createdCategory && onCategoryCreated) { onCategoryCreated(createdCategory); }
  };

  const handleMediaCategoryDeletion = () => {
    setRefreshList((prevState) => !prevState);
  };

  const handleMediaCategoriesCount = (count: number) => {
    setMediaCategoriesCount(count);
  };

  return (
    <div className={classNames(styles.root, embedded && styles.rootEmbedded, nested && styles.rootNested)}>

      <div className={classNames(styles.pageHeader)}>
        <div className={classNames(styles.pageHeaderText)}>
          <h1 className={classNames(styles.pageTitle)}>Rubriques</h1>
          <p className={classNames(styles.pageSubtitle)}>Organisez et gérez les rubriques visibles sur votre chaîne.</p>
        </div>
        {
          onBackToMedia &&
          <button className={classNames(styles.btn, styles.btnPrimary)}
                  onClick={onBackToMedia}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
              <line x1="19" y1="12" x2="5" y2="12"/>
              <polyline points="12 19 5 12 12 5"/>
            </svg>
            Vidéo
          </button>
        }
      </div>

      <div className={classNames(styles.contain)}>
        <div className={classNames(styles.creationPart)}>
          <MediaCategoryCreation
            onCreate      = {handleMediaCategoryCreation}
            numCategories = {mediaCategoriesCount}
          />
        </div>
        <div className={classNames(styles.listPart)}>
          <MediaCategoryList
            refresh             = {refreshList}
            onCategoriesFetched = {handleMediaCategoriesCount}
            onDelete            = {handleMediaCategoryDeletion}
          />
        </div>
      </div>
    </div>
  );
};

export default MediaCategoryManager;
